import angular from 'angular';
import {
  ssDialogService,
  loaderService,
  emDataService,
  vmSharedModelService,
} from 'app/services';
import {
  alerts,
  actionIcon
} from 'app/components/global';
import validator, { name as validatorName } from './messages/vendor-product-unique-name.validator.directive';
import controller from './add-vendor-product-dialog.controller';
import template from './add-vendor-product-dialog.html';
import messageTpl from './messages/vendor-product-name.messages.html';

class dialogService {
  getOptions($event, {
    product, vendorId, addCallback
  }) {
    return {
      controller,
      controllerAs: 'addVendorProductDialogVM',
      locals: {
        product,
        vendorId,
        addCallback
      },
      bindToController: true,
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.advisory.enterpriseModeling.addVendorProductDialog', [
  alerts,
  actionIcon,
  ssDialogService,
  loaderService,
  emDataService,
  vmSharedModelService,
])
  .service('addVendorProductDialog', dialogService)
  .directive(validatorName, validator)
  .run(($templateCache) => {
    $templateCache.put('vendor-product-name.messages.html', messageTpl);
  })
  .name;

console.log('app.components.advisory.enterpriseModeling.addVendorProductDialog created');
